'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _reactRouterDom = require('react-router-dom');

var _Routes = require('./Routes');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Link = require('./Link');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var RedirectWrapper = function (_React$Component) {
  _inherits(RedirectWrapper, _React$Component);

  function RedirectWrapper() {
    _classCallCheck(this, RedirectWrapper);

    return _possibleConstructorReturn(this, (RedirectWrapper.__proto__ || Object.getPrototypeOf(RedirectWrapper)).apply(this, arguments));
  }

  _createClass(RedirectWrapper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          to = _props.to,
          props = _objectWithoutProperties(_props, ['name', 'to']);

      var routes = this.context.routes;
      var route = routes[name];
      var path = route ? (0, _Routes.getPath)(route, props) : props.to;
      var toProps = (0, _Link.calculateToProps)(to, name, routes, props); // filter out all props not supported by Link - boo to unknown props

      var passProps = (0, _lodash.pick)(props, "className", "children", "from", "push");
      console.log("Redirecting to ", path);
      return _react2.default.createElement(_reactRouterDom.Redirect, _extends({}, passProps, {
        to: toProps
      }));
    }
  }]);

  return RedirectWrapper;
}(_react2.default.Component);

RedirectWrapper.contextTypes = {
  routes: _propTypes2.default.object
};
exports.default = RedirectWrapper;